import { render, staticRenderFns } from "./OurTeam.vue?vue&type=template&id=0e7161d4&scoped=true&lang=pug"
import script from "./OurTeam.vue?vue&type=script&lang=js"
export * from "./OurTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7161d4",
  null
  
)

export default component.exports